export default __webpack_public_path__ + "static/media/hero-construction-bg.4d6b2aba.jpeg";